<template>
  <div class="modal-overlay postgame zb_modal">
    <div class="modal-content">
      <img src="/static/images/sparkle_with_book2.png" class="image_half"/>

      <div class="modal-card modal_glow">
        <div class="content">
          <h3 class="top_title">{{ getTranslations.home_modals_zero_balance_zero_game_balance }}</h3>

          <p>{{ getTranslations.home_modals_zero_balance_unlock_more_games_msg }}</p>

          <base-button container-class="go_to_home" @button:click="$emit('redirect:page', {pagePath: '/home/store'})">
            {{ getTranslations.home_modals_zero_balance_unlock_games }}
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseButton from '../../common/button/BaseButton'

export default {
  name: 'zero-balance',
  emits: ['redirect:page'],
  components: {
    BaseButton
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ZeroBalance.vue